module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1032-2dabcce3866a683cb4826e4d5184b88a.png";